module.exports = __webpack_public_path__ + "img/Basic functions-001.3333b712.png";